import { call, put, all, takeLatest, select } from 'redux-saga/effects'
import Api from '../services/ApiManager'
import notification from '../../helpers/notification'
import { Options, execFillRequest } from './effects'
import { fillTranscriptionsActionType, fillTranscriptionSpeechActionType, DialogTranscriptionActionTypes, fillTranscriptionActionType } from '../../model/transcription/action';
import { fillTranscriptionAction, fillTranscriptionSpeechSuccess, fillTranscriptionSpeechFailure, fillTranscriptionSuccess, fillTranscriptionFailure } from '../actions/dialogTranscriptionActions';
import { DialogTranscription, Speech } from '../../model/transcription/types';

function* fillTranscriptions(action: DialogTranscriptionActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
    if(botId !== undefined){
        const options: Options = {
            payload: [botId, action.payload.page, action.payload.startDate, action.payload.endDate, action.payload.filters]
        };
        yield call(execFillRequest,
            Api.transcriptions.get,
            fillTranscriptionAction.success,
            fillTranscriptionAction.failure,
            options);
    }
}

function* fillTranscriptionSpeech(action: DialogTranscriptionActionTypes) {
    try {
        const botId = yield select(state => state.bot.selectedBot);
        const { dialogId } = action.payload;
        const response = yield call(Api.transcriptions.getConversation, botId, dialogId);
        yield put(fillTranscriptionSpeechSuccess(dialogId, response.data as Speech[]));
    } catch (error) {
        yield put(fillTranscriptionSpeechFailure());
        notification.error(
            'Une erreur est survenue, veuillez réessayez ultérieurement',
        );
    }
}


function* fillTranscription(action: DialogTranscriptionActionTypes) {
    try {
        const botId = yield select(state => state.bot.selectedBot);
        const { dialogId } = action.payload;
        const response = yield call(Api.transcriptions.getById, botId, dialogId);
        yield put(fillTranscriptionSuccess(dialogId, response.data as DialogTranscription[]));
    } catch (error) {
        console.log(error)
        yield put(fillTranscriptionFailure());
        notification.error(
            'Une erreur est survenue, veuillez réessayez ultérieurement',
        );
    }
}

export function* startTranscriptionsSagas() {
    yield all([
        takeLatest(fillTranscriptionsActionType.request, fillTranscriptions),
        takeLatest(
            fillTranscriptionSpeechActionType.request,
            fillTranscriptionSpeech
        ),
        takeLatest(fillTranscriptionActionType.request, fillTranscription),
        
    ])
}
